import { ExamCenterProctorType } from '@exam-center/graphql';
import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import {
  parseAsInteger,
  useQueryStates,
  parseAsStringLiteral,
  parseAsString,
  parseAsArrayOf,
} from 'nuqs';

type SortOrder = (typeof dataGridSortDirection)[number];

export default function useAdminProctorListSearchParams() {
  const [
    { page, pageSize, sortOrder, sortBy, search, proctorType, examCenter },
    setAdminProctorListSearchParams,
  ] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    sortBy: parseAsString,
    search: parseAsString.withDefault(''),
    proctorType: parseAsArrayOf(
      parseAsStringLiteral(Object.values(ExamCenterProctorType)),
    ).withDefault([]),
    examCenter: parseAsArrayOf(parseAsString).withDefault([]),
  });

  const changePageNumber = (page: number) => {
    setAdminProctorListSearchParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setAdminProctorListSearchParams({ pageSize, page: 0 });
  };

  const changeSearch = (value: string) => {
    setAdminProctorListSearchParams({ search: value, page: 0 });
  };

  const changeProctorType = (value: ExamCenterProctorType[]) => {
    setAdminProctorListSearchParams({ proctorType: value, page: 0 });
  };

  const changeExamCenter = (value: string[]) => {
    setAdminProctorListSearchParams({ examCenter: value, page: 0 });
  };

  const changeSorting = ({
    sortOrder,
    sortBy,
  }: {
    sortOrder: SortOrder | null;
    sortBy: string | null;
  }) => {
    setAdminProctorListSearchParams({ sortOrder, page: 0, sortBy });
  };

  return [
    { page, pageSize, sortOrder, sortBy, search, proctorType, examCenter },
    {
      changePageNumber,
      changePageSize,
      changeSearch,
      changeProctorType,
      changeExamCenter,
      changeSorting,
    },
  ] as const;
}
